module.exports = (__webpack_require__(46745))(20000);